import axios from "axios";
import AppInstance from "./GlobalAxios";

export default class ApiUtil {
  static async SendAsync(request) {
    try {
      const res = await AppInstance(request);
      return res;
    } catch (error) {
      console.error("API request failed:", error);
      
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error);
      }
      
      // Log the detailed error for debugging
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
      }
      
      throw error;
    }
  }
}
